<template>
	<div>
		<v-dialog v-model="dialog_product" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">
						{{$parent.Form.productDataModel.groupId ? 'Edit Item' : 'Add Item'}}
					</v-toolbar-title>

				    <v-spacer></v-spacer>

				    <!-- <v-btn round-borders outline :disabled="disableBtn" @click="fn_checkValidations()">Done</v-btn> -->
					<v-btn icon dark-opacity-color flat @click="$parent.fn_removeItem(null, $parent.Form.productDataModel.groupId)" v-if="$parent.Form.productDataModel.groupId"><v-icon class="redcolor">delete</v-icon></v-btn>

				    <!-- <v-btn icon @click="fn_getBottomMenu">
				      <v-icon>more_vert</v-icon>
				    </v-btn> -->
				</v-toolbar>
        		<!-- <v-divider></v-divider> -->
        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width class="hasBigFooter">
        	  			<v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs12 sm12 md12 align-msg-right form-item
					        	@click="fn_openProducts">

				               <v-text-field  
					               	readonly
					               	v-model="$parent.Form.productDataModel.productName" 
					               	:hide-details="summaryArray.length ? true : false"
					               	label="Select Item" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	:onUpdate="fn_updateProduct"
					               	ref="ref_dialogProduct_productName"
					               	v-validate="'required'" 
				               		data-vv-name="item" 
				               		:error-messages="errors.collect('fields.item')"
				               		required>
				               </v-text-field>

				               <div custom-message v-if="summaryArray.length">
				               		<span v-for="(item, index) in summaryArray" :key="index">
				               			Stock: <span :class="{'redcolor':item.qty<0}">{{roundUpto2Decimals(item.qty)}} {{item.unitName}}</span>
				               		</span>
				               </div>
				            </v-flex>

						</v-layout>

						<v-layout margin-top-ten row wrap padding-top-ten white-background>

							<!-- :label="$parent.Form.invoiceType == 1 ? 'Amount' : 'Rate'"  -->
					        <v-flex xs12 sm12 md12 form-item>
					           	<v-text-field 
								   	:disabled="disableBtn"
					           		v-model.number="$parent.Form.productDataModel.rate"
					           		:label="$parent.Form.productDataModel.groupTypeId == 101 ? 'Rate' : 'Amount'"
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:4'" 
				               		data-vv-name="rate" 
				               		:error-messages="errors.collect('fields.rate')">
					           	</v-text-field>
					        </v-flex>

					        <v-layout row wrap v-for="(item, vIndex) in $parent.Form.productDataModel.productVariants" :key="vIndex">
					        	 <v-flex xs6 sm6 md6 pr-2 pl-3>
						           	<!-- <v-text-field 
									   	:disabled="disableBtn"
						           		v-model.number="item.qty"
						           		persistent-hint
						           		label="Quantity" 
						           		placeholder="1"
						           		type="number"
						           		v-validate="'numeric|max:8'" 
					               		:data-vv-name="item.unitName+vIndex" 
					               		data-vv-as="quantity"
					               		:error-messages="errors.collect('fields.'+item.unitName+vIndex)">
						           	</v-text-field> -->
									<v-text-field 
									   	:disabled="disableBtn"
										@input="$root.fn_boundDecimalLength(item, null, 'qty')"
						           		v-model="item.qty"
						           		persistent-hint
						           		label="Quantity" 
						           		placeholder="1"
						           		type="number">
						           	</v-text-field>
						        </v-flex>

								<v-flex xs6 sm6 md6 pr-3 pl-2>
									<v-text-field 
										:disabled="true"
										:value="fn_getLabel(item)"
										label="Unit"
										placeholder=" ">
									</v-text-field>
								</v-flex>
					        </v-layout>

						</v-layout>

				        <div white-background v-if="$parent.Form.productDataModel.addOnsItems.length">
				        	<!-- <v-subheader>Discounts/Taxes/Other Charges</v-subheader> -->
				        	<!-- <v-divider></v-divider> -->
					        <v-layout row wrap padding-top-ten v-for="(item, index) in $parent.Form.productDataModel.addOnsItems" :key="index" v-if="!item.isGst">

					        	<v-layout row wrap v-if="item.mode==0">
					        		<v-flex xs6 sm6 md6 form-item pr-2 pl-3>
							           	<v-text-field 
										   :disabled="disableBtn"
							           		v-model.number="item.percentage"
							           		@input="fn_checkPercentage(item)"
							           		:label="item.name"
											suffix="%"
							           		placeholder=" "
							           		type="number"
							           		v-validate="'min_value:0|decimal:2'" 
						               		:data-vv-name="'percent'+index" 
						               		:data-vv-as="item.name"
						               		:error-messages="errors.collect('fields.percent'+index)">
							           	</v-text-field>

							        </v-flex>

							        <v-flex xs6 sm6 md6 form-item pr-3 pl-2>
							           	<v-text-field 
										   	:disabled="disableBtn"
							           		v-model.number="item.value"
							           		@input="item.percentage = null"
							           		prefix="₹"
							           		:suffix="item.nature ? '(-)' : ''"
							           		label=""
							           		placeholder=" "
							           		type="number"
							           		v-validate="'min_value:0|decimal:2'" 
						               		:data-vv-name="'value'+index" 
						               		:data-vv-as="item.name"
						               		:error-messages="errors.collect('fields.value'+index)">
							           	</v-text-field>

							        </v-flex>
					        	</v-layout>

					        	<v-flex xs12 sm12 md12 form-item v-else>
						           	<v-text-field 
									   :disabled="disableBtn"
						           		v-model.number="item.value"
						           		:label="item.name+' (₹)'"
							           	:suffix="item.nature ? '(-)' : ''"
						           		placeholder=" "
						           		type="number"
						           		v-validate="'min_value:0|decimal:2'" 
					               		:data-vv-name="'value'+index" 
					               		:data-vv-as="item.name"
					               		:error-messages="errors.collect('fields.value'+index)">
						           	</v-text-field>

						        </v-flex>

					        </v-layout>
				        </div>

				        <!-- <v-layout row wrap margin-top-ten padding-top-ten white-background v-if="$parent.Form.taxMode && $parent.Form.productDataModel.taxValue!=null"> -->
				        <v-layout row wrap padding-top-ten white-background v-if="$parent.Form.taxMode">

				        	<v-layout row wrap>
				        		<v-flex xs12 sm12 md12 form-item @click="openTaxCategories">
				        			<v-text-field  
						               	readonly
										:disabled="disableBtn"
						               	v-model="$parent.Form.productDataModel.taxCategoryName" 
						               	label="Tax Category" 
						               	placeholder=" " 
						               	append-icon="arrow_drop_down">
					               </v-text-field>
				        		</v-flex>
				        	</v-layout>

				        	<v-layout row wrap>

				        		<v-flex xs6 sm6 md6 pr-2 pl-3>
						           	<v-text-field 
						           		:disabled="true"
						           		v-model="$parent.Form.productDataModel.taxValue"
						           		:label="$parent.Form.isRcmApplicable ? 'GST (RCM)' : 'GST'" 
										suffix="%"
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>

						        <v-flex xs6 sm6 md6 pr-3 pl-2>
						           	<v-text-field 
						           		:disabled="true"
						           		v-model="$parent.Form.productDataModel.taxAmount"
						           		label="" 
						           		prefix="₹"
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>   

				        	</v-layout>

				        	<!-- v-if="$parent.Form.productDataModel.cessValue" -->
				        	<v-layout row wrap v-if="$parent.Form.productDataModel.isCessApplicable">

				        		<v-flex xs6 sm6 md6 pr-2 pl-3>
						           	<v-text-field 
						           		:disabled="true"
						           		v-model="$parent.Form.productDataModel.cessValue"
						           		:label="$parent.Form.isRcmApplicable ? 'Cess (RCM)' : 'Cess'" 
										suffix="%" 
						           		placeholder=" ">
						           	</v-text-field>
						        </v-flex>

						        <v-flex xs6 sm6 md6 pr-3 pl-2>
						           	<v-text-field 
									   	:disabled="true"
						           		@input="$parent.Form.productDataModel.cessValue = null"
						           		type="number"
						           		v-model.number="$parent.Form.productDataModel.cessAmount"
						           		label="" 
						           		prefix="₹"
						           		placeholder=" "
						           		v-validate="'min_value:0|decimal:2'" 
					               		data-vv-name="cessAmount" 
					               		data-vv-as="cess amount" 
					               		:error-messages="errors.collect('fields.cessAmount')">
						           	</v-text-field>
						        </v-flex>   

				        	</v-layout>

					        <v-flex xs12 sm12 md12 form-item v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && $root.CurrentBusiness.HSNApplicable">
					           	<v-text-field 
								   	:disabled="disableBtn"
					           		v-model="$parent.Form.productDataModel.hsnCode"
					           		label="HSN" 
					           		placeholder=" "
					           		v-validate="'verify_hsn'" 
				               		data-vv-name="hsn" 
				               		:error-messages="errors.collect('fields.hsn')">
					           	</v-text-field>
					        </v-flex>
				        </v-layout>

						<v-list full-width nopadding v-if="netAmount">
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>Item Total</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									&#8377; {{$root.numberToLocale(netAmount)}}
									<!-- <span v-if="$parent.Form.isRcmApplicable">
										&#8377; {{$root.numberToLocale(netAmount - $parent.Form.productDataModel.taxAmount - $parent.Form.productDataModel.cessAmount)}}
									</span>
									<span v-else>
										&#8377; {{$root.numberToLocale(netAmount)}}
									</span> -->
								</v-list-tile-action>
								<!-- <v-list-tile-action>&#8377; {{$root.numberToLocale(netAmount)}}</v-list-tile-action> -->
							</v-list-tile>
						</v-list>

						<v-layout wrap margin-top-ten pb-3 pt-3 white-background>
							<v-flex xs12 sm12 md12 form-item>
								<v-textarea
									:disabled="disableBtn"
									v-validate="'max:255'"
									data-vv-name="notes" 
									:error-messages="errors.collect('fields.notes')"
									v-model="$parent.Form.productDataModel.description"
									label="Notes"
									placeholder=" "
									rows="2"
									:counter="255">
								</v-textarea>
							</v-flex>
						</v-layout>
						
        	  		</v-form>
        	  		
        	  	</v-card-text>
        	  	<!-- <v-divider></v-divider>
		        <v-card-actions :class="{'error--text':netAmount<0}">
		          Amount<v-spacer></v-spacer>&#8377; {{netAmount ? $root.numberToLocale(netAmount) : netAmount}}
		        </v-card-actions> -->
				<div white-background full-width nopadding style="position:fixed;bottom:0;">
					<v-layout row wrap style="background:#ddd;">
						<v-flex xs6 sm6 md6>
							<v-btn style="height:48px !important" nomargin block no-round-borders noshadow :disabled="disableBtn" @click="fn_checkValidations(true)">Done & New</v-btn>
						</v-flex>
						<v-flex xs6 sm6 md6>
							<v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow :disabled="disableBtn" @click="fn_checkValidations(false)">Done</v-btn>
						</v-flex>
					</v-layout>
				</div>
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
const menuItem = require('../../../../../config.js').configs.menuItem;
const transactionTypes = require('../../../../../config.js').configs.transactionTypes;

export default{
	props:['openProducts', 'openTaxCategories', 'saveItem'],
	data(){	
		return{
			dialog_product: false,
			summaryArray:[],
			disableBtn:false
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.$validator.reset();
			this.summaryArray = [];
			this.dialog_product = true;
		},
		closeDialogWeb: function () {
			this.dialog_product = false;
		},
		fn_openProducts: function () {
			this.openProducts('android', 'Products', 'ref_dialogProduct_productName', this.$parent.Form.productDataModel.productId, this.$parent.Form.productDataModel.productName);
		},
		fn_updateProduct: function (selectedValueId, selectedValueName, isRemoved) {
			if(!isRemoved){
				this.$parent.Form.productDataModel.productId = selectedValueId;
	        	this.$parent.Form.productDataModel.productName = selectedValueName;
	        	this.$forceUpdate();
	        	this.errors.remove('fields.item');
	        	// this.fn_getItem(selectedValueId)
	        	this.fn_getProductData(false, selectedValueId);
	        	// this.fn_getSummary(selectedValueId);
			}
			else{
				this.$parent.Form.productDataModel.productId = null;
	        	this.$parent.Form.productDataModel.productName = null;
			}
		},
		// fn_getItem: function(itemId){
		// 	let itemExist = false;

		// 	let itemIndex = this.$parent.Form.items.findIndex(item=>{
		// 		return item.productId == itemId
		// 	})

		// 	if(itemIndex!=-1){
		// 		let self =this;
		// 		setTimeout(function () {
		// 			self.editItem(self.$parent.Form.items[itemIndex]);
		// 		},300)
		// 	}
		// 	else{
		// 		this.fn_getProductData(false, itemId);
		// 	}
		// },
		fn_getProductData: function (refreshUnits, itemId, baseTransactionListId) {
			let self = this;
			this.getData('Product', itemId, 
				{
					onSuccess: function(response){
			          console.log(response);
			          let productData = JSON.parse(response);

			          // if(self.$parent.Form.invoiceType==0){
			          // 	self.fn_getSummary(productData.productId);
			          // }
			          if(productData.groupTypeId==101){
			          	self.fn_getSummary(productData.productId);
			          }

			          if(refreshUnits){
			          	self.fn_refreshUnits(productData.productVariants, baseTransactionListId);
			          }
			          else{
			          	self.fn_bindData(productData);
			          }
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_refreshUnits: function (variants, baseTransactionListId) {
			let productVariants = this.$parent.Form.productDataModel.productVariants;
      		if(variants.length != productVariants.length){

				for(var j in variants){
				   	var shared = false;

				   	for (var k in productVariants){
				   		if (productVariants[k].productVariantId == variants[j].productVariantId) {
				           shared = true;
				           break;
				       }
				   	}
				       
				   	if(!shared){
				   		let variantObj = {};

			          	variantObj.unitName = variants[j].unitName;
			          	variantObj.unitId = variants[j].unitId;
			          	variantObj.primaryUnitId = variants[j].variantBaseUnitId;
			          	variantObj.packQuantity = variants[j].packQuantity;
			          	variantObj.productId = variants[j].productId;
			          	variantObj.productVariantId = variants[j].productVariantId;

			          	variantObj.qty = null;

			          	//adding bill qty 0 while ading variant in case of edit
			          	if(this.$parent.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id && baseTransactionListId == transactionTypes.purchaseInvoice.id){
			          		variantObj.billQty = 0;
			          	}

			          	productVariants.splice(j, 0, variantObj);
				   	} 
				}

			}
		},
		fn_bindData: function (productData) {
			this.$parent.Form.productDataModel.groupTypeId = productData.groupTypeId;
			this.$parent.Form.productDataModel.productVariants = JSON.parse(JSON.stringify(productData.productVariants));
			this.$parent.Form.productDataModel.mrp = productData.mrp;

			self = this;
			this.$parent.Form.productDataModel.productVariants.forEach( function(item) {
				item.primaryUnitId = item.variantBaseUnitId;
				// productData.groupTypeId == 102 ? self.$set(item, 'qty', 1) : '';
				self.$set(item, 'qty', 1);

				//setting pack quantity 1 in case of null or base variant
				!item.packQuantity ? item.packQuantity = 1 : '';
			});

			this.$parent.Form.productDataModel.rate = productData.purchaseRate;


			// this.$parent.Form.productDataModel.taxValue = productData.taxValue;
			// this.$parent.Form.productDataModel.cessValue = productData.cessValue;
			this.$parent.Form.productDataModel.hsnCode = productData.hsnCode;

			// if(productData && productData.purchaseTaxCategoryId){
			// 	this.$parent.Form.productDataModel.taxCategoryId = productData.purchaseTaxCategoryId;
			// 	this.$parent.Form.productDataModel.taxCategoryName = productData.purchaseTaxCategoryName;
			// 	this.$parent.Form.productDataModel.taxValue = productData.purchaseTaxValue;
			// 	this.$parent.Form.productDataModel.cessValue = productData.purchaseCessValue;
			// 	this.$parent.Form.productDataModel.isCessApplicable = productData.purchaseIsCessApplicable;

			// 	//saving default tax value for draft
			// 	this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.purchaseTaxCategoryId;
			// 	this.$parent.Form.productDataModel.defaultTaxValue = productData.purchaseTaxValue;
			// 	this.$parent.Form.productDataModel.defaultCessValue = productData.purchaseCessValue;
			// 	this.$parent.fn_checkTaxCategory();
			// }
			// else{
				if(this.$parent.fn_isNewTaxForm()){
					this.$parent.Form.productDataModel.taxCategoryId = productData.newTaxCategoryId;
					this.$parent.Form.productDataModel.taxCategoryName = productData.newTaxCategoryName;
					this.$parent.Form.productDataModel.taxValue = productData.newTaxValue;
					this.$parent.Form.productDataModel.cessValue = productData.newCessValue;
					// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

					//saving default tax value for draft
					this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.newTaxCategoryId;
					this.$parent.Form.productDataModel.defaultTaxValue = productData.newTaxValue;
					this.$parent.Form.productDataModel.defaultCessValue = productData.newCessValue;

					this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable || productData.newCessValue || productData.newCessValueOnQuantity ? true : false;
					this.$parent.fn_checkTaxCategory();
				}
				else{
					this.$parent.Form.productDataModel.taxCategoryId = productData.taxCategoryId;
					this.$parent.Form.productDataModel.taxCategoryName = productData.taxCategoryName;
					this.$parent.Form.productDataModel.taxValue = productData.taxValue;
					this.$parent.Form.productDataModel.cessValue = productData.cessValue;
					// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;

					//saving default tax value for draft
					this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.taxCategoryId;
					this.$parent.Form.productDataModel.defaultTaxValue = productData.taxValue;
					this.$parent.Form.productDataModel.defaultCessValue = productData.cessValue;

					this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable || productData.cessValue || productData.cessValueOnQuantity ? true : false;
				}
				
				// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;
				
			// }
			
			// this.$parent.Form.productDataModel.taxCategoryId = productData.taxCategoryId;
			// this.$parent.Form.productDataModel.taxCategoryName = productData.taxCategoryName;
			// this.$parent.Form.productDataModel.defaultTaxCategoryId = productData.taxCategoryId;
			// this.$parent.Form.productDataModel.isCessApplicable = productData.isCessApplicable;


			//saving default tax value for draft
			// this.$parent.Form.productDataModel.defaultTaxValue = productData.taxValue;
			// this.$parent.Form.productDataModel.defaultCessValue = productData.cessValue;

			//charges in case of service item
			if(this.$parent.Form.productDataModel.groupTypeId==102){
				this.$parent.Form.productDataModel.rate = productData.charges;	
			}
			// if(self.$parent.Form.invoiceType==1){
			// 	this.$parent.Form.productDataModel.rate = productData.charges;	
			// }
		},
		fn_getLabel: function (item) {
			return item.unitName
			// if(!item.packQuantity){
			// 	return item.unitName;
			// }
			// else{
			// 	return item.unitName+'('+item.packQuantity+')';
			// }
		},
		fn_getSummary: function (itemId) {
			var self = this;
			this.getData('ProductSummary', itemId, 
				{
					onSuccess: function(response){
						console.log(response);
						self.summaryArray = JSON.parse(response);
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_getAddOnsLabel: function (item) {
			let label = item.name;
			item.mode == 0 ? label = label+'(%)' : '';
			return label;
		},

		fn_checkValidations: function(doneAndNew){
			this.disableBtn = true;
			let quantityFilled = false;

			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
		        	this.$parent.Form.productDataModel.netAmount = this.netAmount;
		        	let quantityFilled = false;

		        	for(let i=0; i<this.$parent.Form.productDataModel.productVariants.length; i++){
		        		// if(this.$parent.Form.productDataModel.productVariants[i].qty){
		        		// 	quantityFilled = true;
		        		// 	break;
		        		// }
		        		if(!this.$parent.Form.productDataModel.productVariants[i].qty){
		        			this.$parent.Form.productDataModel.productVariants[i].qty = 1;
		        		}
		        	}

		        	// if(!quantityFilled){
		        	// 	this.showToast("Please add quantity");
		        	// 	this.disableBtn = false;
		        	// }
		        	if(this.netAmount<0){
		        		// this.$parent.snackbar_msg = "Amount cannot be negative."
		        		// this.$parent.snackbar = true;	
		        		this.showToast("Amount cannot be negative");
		        		this.disableBtn = false;
		        	}
		        	else{
		        		this.saveItem(this.$parent.Form.productDataModel, doneAndNew);
		        	}
		           	
		        }
		        else{
		        	this.disableBtn = false;
		        }
		    });
		},

		fn_checkPercentage: function (item) {
			!item.percentage ? item.value = null : '';
		},

		fn_computeValues: function (productData) {
			let grossAmount = 0;
			let grossAmountAsPerMRP = 0;

			let netValue = 0;
			// let finalAmount = 0;

			let self = this;

			//Calculating gross amount
			productData.productVariants.forEach(function (item) {
				let packQty = 1;
				let qty = 1;
				let rate = productData.rate;

				item.packQuantity ? packQty = item.packQuantity : '';

				item.qty ? qty = item.qty : '';

				//calculation as per rate
				if(!qty || !rate)
					grossAmount += 0;
				else{
					grossAmount += qty * packQty * rate;
				}

				//calculation as per mrp
				let mrp = productData.mrp;
				if(!qty || !mrp)
					grossAmountAsPerMRP += 0;
				else{
					grossAmountAsPerMRP += qty * packQty * mrp;
				}
			})

			productData.grossAmount = this.roundUpto2Decimals(grossAmount);
			productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);

			grossAmount = this.roundUpto2Decimals(grossAmount);
			grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);
			netValue = this.roundUpto2Decimals(grossAmount);

			//calculating addons
			let mrp = productData.mrp ? productData.mrp : 0;
			let addOnsTotalValue = 0;

			// let itemTaxAmount = 0;
			// let addibleTax = 0;

			productData.addOnsItems.forEach(function (item) {

				let applicableAmount = 0;
				let addOnsValue = 0;

				//on net value
				if(item.appliedOn == 0){
					applicableAmount = netValue;
				}//value of goods
				else if(item.appliedOn == 1){
					applicableAmount = grossAmount;
				}//on mrp
				else{
					applicableAmount = grossAmountAsPerMRP;
				}

				//Caculating addOns except gst's
				if(!item.isGst){
					//of value or percentage
					if(item.mode){//value
						addOnsValue = item.value;
					}
					else{//percentage
						if(item.percentage){
							addOnsValue = (applicableAmount*item.percentage)/100;
							item.value = self.roundUpto2Decimals(addOnsValue);
						}
						else if(item.value){
							addOnsValue = item.value;
						}
					}
				}
				

				addOnsValue = self.roundUpto2Decimals(addOnsValue);

				//Final calculation
				if(item.adjustInTotal){
					if(item.nature==0){
						netValue = netValue + addOnsValue;
					}
					else{
						netValue = netValue - addOnsValue;
					}
				}		

			});

			//Taxable amount is net value after deduction of addons on which tax(gst) will apply
			productData.taxableValue = this.roundUpto2Decimals(netValue);
			//Tax will only affect net amount in case of exclusive tax where this.$parent.Form.taxMode == 1

			let itemTaxAmount = 0;
			let addibleTax = 0;
			let itemCessAmount = 0;
			if(this.$parent.Form.taxMode){

				let taxTotalPercent = productData.taxValue;
				if(productData.isCessApplicable){
					taxTotalPercent = taxTotalPercent + productData.cessValue;
				}

				let taxAmountInclusive = null;

				if(productData.taxValue && self.$parent.Form.taxMode==2){
					// taxAmountInclusive = (netValue * productData.taxValue)/(100+productData.taxValue);
					let taxPer = productData.taxValue / self.$parent.Form.gstAddOns.length;
					taxAmountInclusive = (netValue * taxPer)/(100+taxTotalPercent);
				}
				

				this.$parent.Form.gstAddOns.forEach(function (item) {

					if(productData.taxValue){
						let gstCategoriesLength = self.$parent.Form.gstAddOns.length;

						let percentage = productData.taxValue / gstCategoriesLength;

						item.percentage = percentage;

						//exclusive tax
						if(self.$parent.Form.taxMode==1){
							let taxAmount = (netValue * item.percentage)/100;
							item.value = self.roundUpto2Decimals(taxAmount);
							addibleTax += item.value ? item.value : 0;
							itemTaxAmount += item.value;
						}
						//inclusive tax
						else if(self.$parent.Form.taxMode==2){
							// let taxAmount = (netValue * item.percentage)/(100+item.percentage);
							// item.value = self.roundUpto2Decimals(taxAmountInclusive/gstCategoriesLength);
							item.value = self.roundUpto2Decimals(taxAmountInclusive);
							itemTaxAmount += item.value;
						}
					}

				});

				//Calculation of cess

				if(productData.isCessApplicable){

					this.$parent.Form.cessAddOns.percentage = productData.cessValue;

					//exclusive tax
					if(self.$parent.Form.taxMode==1){
						if(productData.cessValue!=null){
							let cessAmount = (netValue * this.$parent.Form.cessAddOns.percentage)/100;
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmount);
							addibleTax += this.$parent.Form.cessAddOns.value ? this.$parent.Form.cessAddOns.value : 0;	
							itemCessAmount = this.$parent.Form.cessAddOns.value;
						}
						else{
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(productData.cessAmount);
							addibleTax += productData.cessAmount ? productData.cessAmount : 0;	
							itemCessAmount = productData.cessAmount;
						}
						
					}
					//inclusive tax
					else if(self.$parent.Form.taxMode==2){
						if(productData.cessValue!=null){
							// let cessAmountInclusive = (netValue * productData.cessValue)/(100+productData.cessValue);
							let cessAmountInclusive = (netValue * productData.cessValue)/(100+taxTotalPercent);
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(cessAmountInclusive);
							itemCessAmount = this.$parent.Form.cessAddOns.value;
						}
						else{
							this.$parent.Form.cessAddOns.value = self.roundUpto2Decimals(productData.cessAmount);
							itemCessAmount = productData.cessAmount;
						}

					}

				}
			}

			productData.taxAmount = self.roundUpto2Decimals(itemTaxAmount);
			productData.cessAmount = self.roundUpto2Decimals(itemCessAmount);

			if(productData.cessValue==null && itemCessAmount===''){
				productData.cessAmount = null;
			}

			//Taxable amount is net value after deduction of addons on which tax(gst) will apply
			//taxable value in case of exclusive tax
			// if(this.$root.CurrentBusiness.GSTRegistrationStatus!=3){
			productData.taxableValue = this.roundUpto2Decimals(netValue);
			// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
			// 	productData.taxableValue = this.roundUpto2Decimals(netValue);	
			// }
			// else{
			// 	productData.taxableValue = this.roundUpto2Decimals(netValue + addibleTax);
			// }

			//Gross amount in case of inclusive tax
			if(self.$parent.Form.taxMode==2){
				productData.grossAmount = this.roundUpto2Decimals(grossAmount - itemTaxAmount - itemCessAmount);
				productData.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP - itemTaxAmount - itemCessAmount);
				//taxable value in case of inclusive tax
				// if(this.$root.CurrentBusiness.GSTRegistrationStatus!=3){
				productData.taxableValue = this.roundUpto2Decimals(netValue - itemTaxAmount - itemCessAmount);
				// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
				// 	productData.taxableValue = this.roundUpto2Decimals(netValue - itemTaxAmount - itemCessAmount);	
				// }
				// else{
				// 	productData.taxableValue = this.roundUpto2Decimals(netValue);
				// }
			}

			//calculating net amount after default tax
			if(this.$parent.Form.isRcmApplicable){
				return this.roundUpto2Decimals(netValue);	
			}
			else{
				return this.roundUpto2Decimals(netValue + addibleTax);
			}
			// netValue = netValue + addibleTax;

			// return this.roundUpto2Decimals(netValue);
		}
	},
	computed:{
		netAmount: function () {
			return this.fn_computeValues(this.$parent.Form.productDataModel);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/expense/dialogs/dialog_product.vue